import React from 'react';
import {MasterLayout} from 'layout';
import { header } from 'constants/table';
import {ThongKeBaoCao} from 'api';
import DataTable from 'components/data-table';
import {
  RowItemKetQuaThanhTraHanhChinh,
  RowItemKetQuaThanhTraTaiChinhNganHang,
  RowItemKetQuaThanhTraLai,
  RowItemKetQuaThanhTraChuyenNganh,
  RowItemKetQuaThanhTraDatDai,
  RowItemKetQuaXuLyThamNhung,
  RowItemCongTacXayDung,
  RowItemKetQuaTiepCongDan,
  RowItemXLDKhieuNaiToCao,
  RowItemGQDKN,
  RowItemGQDTC,
  RowItemQLNNKNTC,
  RowItemSLKKXMTS,
  RowItemCongTacQuanLyThanhTra
} from './datatable';
import TableKetQuaPhongChongThamNhung from 'modules/bao-cao-dinh-ky/TableKetQuaPhongChongThamNhung.jsx';
import {ContainerFileDinhKem} from 'components/upload';
import {Link, browserHistory} from 'react-router';
import { Button } from '@blueprintjs/core';
import { Text } from 'components/tt-forms/common';
import { ShowIf } from 'components/utils';

class ChiTietBaoCaoTaiDonVi extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      data: {
        listTaiLieuBaoCao: [],
        baoCaoTongHopInfo: {},
        donViConsInfo: []
      },
      rowData: [],
      tableLoading: false,
      totalCol: 0,
      header: [],
      dataSum: {}
    }
  }

  componentDidMount() {
    if (this.props.params.id) {
      this.getInfo(this.props.params.id);
      this.getRowDuLieu(this.props.params.id);
    }
  }

  getInfo(idBC) {
    ThongKeBaoCao.actions.getBaoCaoDonViChiTiet.request({id: idBC}).then(res => {
      if (res.data) {
        res.data.listTaiLieuBaoCao = res.data.listTaiLieuBaoCao.map(item => {
          return item = {
            ...item,
            soQuyetDinh: item.soVanBan,
            ngayQuyetDinh: item.ngayRaVanBan
          }
        });
        this.state.data = res.data;
        this.state.dataSum = res.data;
        this.setState({...this.state});
      }
    });
  }
  getRowDuLieu(idBC) {
    this.setState({tableLoading: true});
    ThongKeBaoCao.actions.getBaoCaoDonViChiTietRow.request({id: idBC}).then(res => {
      if (res.data && res.data._embedded) {
        res.data._embedded.baoCaoDonViChiTiets.map(item => {
          item.donVi = {
            ten: item.soLieuBaoCaoInfo.tenDonVi,
            id: item.donViInfo ? item.donViInfo.donViId : ''
          };
        });
        this.setState({
          rowData: res.data._embedded.baoCaoDonViChiTiets,
          tableLoading: false
        });
      } else {
        this.setState({
          rowData: [],
          tableLoading: false
        });
      }
    });
  }

  render() {
    return (
      <MasterLayout routerName={this.props.route.name}>
        <div className="center reception-container wrap-block" ref='thongKeBaoCao'>
          <div className="back-foward mb0">
            <Link onClick={browserHistory.goBack}>Về trang trước</Link>
          </div>
          <div className="top-content">
            <div className="left-content">
              <ShowIf condition={this.state.data.thongTinBaoCaoInfo && this.state.data.thongTinBaoCaoInfo.kyBaoCao == 'THEO_QUY'}>
                <p className="title-18"><i className="tt tt-thongke"></i>{`Tổng hợp ${this.state.data.loaiBaoCaoInfo ? this.state.data.loaiBaoCaoInfo.ten : ''} quý ${this.state.data.thongTinBaoCaoInfo ? this.state.data.thongTinBaoCaoInfo.quyBaoCao : ''} năm ${this.state.data.thongTinBaoCaoInfo ? this.state.data.thongTinBaoCaoInfo.namBaoCao : ''}`}</p>
              </ShowIf>
              <ShowIf condition={this.state.data.thongTinBaoCaoInfo && this.state.data.thongTinBaoCaoInfo.kyBaoCao == 'THEO_THANG'}>
                <p className="title-18"><i className="tt tt-thongke"></i>{`Tổng hợp ${this.state.data.loaiBaoCaoInfo ? this.state.data.loaiBaoCaoInfo.ten : ''} tháng ${this.state.data.thongTinBaoCaoInfo ? this.state.data.thongTinBaoCaoInfo.thangBaoCao : ''} năm ${this.state.data.thongTinBaoCaoInfo ? this.state.data.thongTinBaoCaoInfo.namBaoCao : ''}`}</p>
              </ShowIf>
              <ShowIf condition={this.state.data.thongTinBaoCaoInfo && this.state.data.thongTinBaoCaoInfo.kyBaoCao != 'THEO_THANG' && this.state.data.thongTinBaoCaoInfo.kyBaoCao != 'THEO_QUY'}>
                <p className="title-18"><i className="tt tt-thongke"></i>{`Tổng hợp ${this.state.data.loaiBaoCaoInfo ? this.state.data.loaiBaoCaoInfo.ten : ''} ${this.state.data.thongTinBaoCaoInfo ? this.state.data.thongTinBaoCaoInfo.kyBaoCaoText : ''} năm ${this.state.data.thongTinBaoCaoInfo ? this.state.data.thongTinBaoCaoInfo.namBaoCao : ''}`}</p>
              </ShowIf>
            </div>
          </div>
          <div className="bottom-content thongke-content">
            <div className='row pl10 pr10'>
              <h2 className='title-14 col-100 pt20 pl20 pr20'>1. Thông tin báo cáo</h2>
            </div>
            <div className='row pl25 pr25'>
              <Text className='col-100 mt15' label='Biểu mẫu:' value={this.state.data.loaiBaoCaoInfo ? this.state.data.loaiBaoCaoInfo.ten : ''}/>
              <Text className='col-input mt15' label='Kỳ báo cáo:' value={this.state.data.thongTinBaoCaoInfo ? this.state.data.thongTinBaoCaoInfo.kyBaoCaoText : ''}/>
              <Text className='col-input mt15' label='Năm báo cáo:' value={this.state.data.thongTinBaoCaoInfo ? this.state.data.thongTinBaoCaoInfo.namBaoCao : ''}/>
              <ShowIf condition={this.state.data.thongTinBaoCaoInfo && this.state.data.thongTinBaoCaoInfo.kyBaoCao == 'THEO_QUY'}>
                <Text className='col-input mt15' label='Quý:' value={this.state.data.thongTinBaoCaoInfo ? this.state.data.thongTinBaoCaoInfo.quyBaoCao : ''} />
              </ShowIf>
              <ShowIf condition={this.state.data.thongTinBaoCaoInfo && this.state.data.thongTinBaoCaoInfo.kyBaoCao == 'THEO_THANG'}>
                <Text className='col-input mt15' label='Tháng:' value={this.state.data.thongTinBaoCaoInfo ? this.state.data.thongTinBaoCaoInfo.thangBaoCao + 1 : ''} />
              </ShowIf>

              <Text className='col-100 mt15 mb15' label='Đơn vị:' value={this.state.data.baoCaoDonViInfo ? this.state.data.baoCaoDonViInfo.tenDonVi : ''}/>
            </div>
            <div className='row pl15 pr15 pb15'>
              <span className='big-border'></span>
            </div>
            <div className='row pl10 pr10'>
              <h2 className='title-14 col-100 pl20 pr20'>2. Số liệu báo cáo</h2>
            </div>
            <div className="wrap-table clear-left">
                <ShowIf condition={this.state.data.loaiBaoCao == 'KET_QUA_THANH_TRA_HANH_CHINH'}>
                  <DataTable
                    touchMove={true}
                    header={header.thongKeBaoCaoThanhTraHanhChinh}
                    dataSum={this.state.dataSum}
                    hidePagination={true}
                    numberColumnHeader={33}
                    ThongKeBaoCao={true}
                    dataList={this.state.rowData}
                    hideExport={true}
                    parent={this}
                    tableLoading={this.state.tableLoading}>
                    <RowItemKetQuaThanhTraHanhChinh/>
                  </DataTable>
                </ShowIf>
                <ShowIf condition={this.state.data.loaiBaoCao == 'KET_QUA_THANH_TRA_TRONG_LINH_VUC_DAU_TU_XAY_DUNG_CO_BAN'}>
                  <DataTable
                    touchMove={true}
                    header={header.thongKeBaoCaoThanhTraXayDungCoBan}
                    dataSum={this.state.dataSum}
                    hidePagination={true}
                    numberColumnHeader={33}
                    ThongKeBaoCao={true}
                    dataList={this.state.rowData}
                    hideExport={true}
                    parent={this}
                    tableLoading={this.state.tableLoading}>
                    <RowItemKetQuaThanhTraHanhChinh/>
                  </DataTable>
                </ShowIf>
                <ShowIf condition={this.state.data.loaiBaoCao == 'KET_QUA_THANH_TRA_TRONG_LINH_VUC_TAI_CHINH_NGAN_SACH'}>
                  <DataTable
                    touchMove={true}
                    header={header.thongKeBaoCaoThanhTraTaiChinhNganSach}
                    dataSum={this.state.dataSum}
                    hidePagination={true}
                    numberColumnHeader={27}
                    ThongKeBaoCao={true}
                    dataList={this.state.rowData}
                    hideExport={true}
                    parent={this}
                    tableLoading={this.state.tableLoading}>
                    <RowItemKetQuaThanhTraTaiChinhNganHang/>
                  </DataTable>
                </ShowIf>
                <ShowIf condition={this.state.data.loaiBaoCao == 'KET_QUA_THANH_TRA_TRONG_LINH_VUC_DAT_DAI'}>
                  <DataTable
                    touchMove={true}
                    header={header.thongKeBaoCaoThanhTraDatDai}
                    dataSum={this.state.dataSum}
                    hidePagination={true}
                    numberColumnHeader={43}
                    ThongKeBaoCao={true}
                    dataList={this.state.rowData}
                    hideExport={true}
                    parent={this}
                    tableLoading={this.state.tableLoading}>
                    <RowItemKetQuaThanhTraDatDai/>
                  </DataTable>
                </ShowIf>
                <ShowIf condition={this.state.data.loaiBaoCao == 'KET_QUA_THANH_TRA_LAI'}>
                  <DataTable
                    touchMove={true}
                    header={header.thongKeBaoCaoThanhTraLai}
                    dataSum={this.state.dataSum}
                    hidePagination={true}
                    numberColumnHeader={31}
                    ThongKeBaoCao={true}
                    dataList={this.state.rowData}
                    hideExport={true}
                    parent={this}
                    tableLoading={this.state.tableLoading}>
                    <RowItemKetQuaThanhTraLai/>
                  </DataTable>
                </ShowIf>
                <ShowIf condition={this.state.data.loaiBaoCao == 'KET_QUA_THANH_TRA_KIEM_TRA_CHUYEN_NGANH'}>
                  <DataTable
                    touchMove={true}
                    header={header.thongKeBaoCaoThanhTraChuyenNganh}
                    dataSum={this.state.dataSum}
                    hidePagination={true}
                    numberColumnHeader={29}
                    ThongKeBaoCao={true}
                    dataList={this.state.rowData}
                    hideExport={true}
                    parent={this}
                    tableLoading={this.state.tableLoading}>
                    <RowItemKetQuaThanhTraChuyenNganh/>
                  </DataTable>
                </ShowIf>
                <ShowIf condition={this.state.data.loaiBaoCao == 'KET_QUA_PHAT_HIEN_XU_LY_THAM_NHUNG_QUA_THANH_TRA'}>
                  <DataTable
                    touchMove={true}
                    header={header.thongKeBaoCaoThanhTraThamNhung}
                    dataSum={this.state.dataSum}
                    hidePagination={true}
                    numberColumnHeader={27}
                    ThongKeBaoCao={true}
                    dataList={this.state.rowData}
                    hideExport={true}
                    parent={this}
                    tableLoading={this.state.tableLoading}>
                    <RowItemKetQuaXuLyThamNhung/>
                  </DataTable>
                </ShowIf>
                <ShowIf condition={this.state.data.loaiBaoCao == 'CONG_TAC_QUAN_LY_NHA_NUOC_VE_THANH_TRA'}>
                  <DataTable
                    touchMove={true}
                    header={header.nhaNuocVeThanhTra}
                    dataSum={this.state.dataSum}
                    hidePagination={true}
                    numberColumnHeader={23}
                    ThongKeBaoCao={true}
                    dataList={this.state.rowData}
                    hideExport={true}
                    parent={this}
                    tableLoading={this.state.tableLoading}>
                    <RowItemCongTacQuanLyThanhTra/>
                  </DataTable>
                </ShowIf>
                <ShowIf condition={this.state.data.loaiBaoCao == 'CONG_TAC_XAY_DUNG_LUC_LUONG_THANH_TRA'}>
                  <DataTable
                    touchMove={true}
                    header={header.xayDungLucLuongThanhTra}
                    dataSum={this.state.dataSum}
                    hidePagination={true}
                    numberColumnHeader={26}
                    ThongKeBaoCao={true}
                    dataList={this.state.rowData}
                    hideExport={true}
                    parent={this}
                    tableLoading={this.state.tableLoading}>
                    <RowItemCongTacXayDung/>
                  </DataTable>
                </ShowIf>
                <ShowIf condition={this.state.data.loaiBaoCao == 'KET_QUA_TIEP_CONG_DAN'}>
                  <DataTable
                    touchMove={true}
                    header={header.thongKeBaoCaoTiepCongDan}
                    dataSum={this.state.dataSum}
                    hidePagination={true}
                    numberColumnHeader={37}
                    ThongKeBaoCao={true}
                    dataList={this.state.rowData}
                    hideExport={true}
                    parent={this}
                    tableLoading={this.state.tableLoading}>
                    <RowItemKetQuaTiepCongDan/>
                  </DataTable>
                </ShowIf>
                <ShowIf condition={this.state.data.loaiBaoCao == 'KET_QUA_XU_LY_DON_KHIEU_NAI_TO_CAO'}>
                  <DataTable
                    touchMove={true}
                    header={header.thongKeBaoCaoXuLyDon}
                    dataSum={this.state.dataSum}
                    hidePagination={true}
                    numberColumnHeader={33}
                    ThongKeBaoCao={true}
                    dataList={this.state.rowData}
                    hideExport={true}
                    parent={this}
                    tableLoading={this.state.tableLoading}>
                    <RowItemXLDKhieuNaiToCao/>
                  </DataTable>
                </ShowIf>
                <ShowIf condition={this.state.data.loaiBaoCao == 'KET_QUA_GIAI_QUYET_DON_KHIEU_NAI'}>
                  <DataTable
                    touchMove={true}
                    header={header.thongKeBaoCaoGiaiQuyetDonKN}
                    dataSum={this.state.dataSum}
                    hidePagination={true}
                    numberColumnHeader={40}
                    ThongKeBaoCao={true}
                    dataList={this.state.rowData}
                    hideExport={true}
                    parent={this}
                    tableLoading={this.state.tableLoading}>
                    <RowItemGQDKN/>
                  </DataTable>
                </ShowIf>
                <ShowIf condition={this.state.data.loaiBaoCao == 'KET_QUA_GIAI_QUYET_DON_TO_CAO'}>
                  <DataTable
                    touchMove={true}
                    header={header.thongKeBaoCaoGiaiQuyetDonTC}
                    dataSum={this.state.dataSum}
                    hidePagination={true}
                    numberColumnHeader={35}
                    ThongKeBaoCao={true}
                    dataList={this.state.rowData}
                    hideExport={true}
                    parent={this}
                    tableLoading={this.state.tableLoading}>
                    <RowItemGQDTC/>
                  </DataTable>
                </ShowIf>
                <ShowIf condition={this.state.data.loaiBaoCao == 'CONG_TAC_QUAN_LY_NHA_NUOC_VE_KHIEU_NAI_TO_CAO'}>
                  <DataTable
                    touchMove={true}
                    header={header.quanLyNhaNuocVeKhieuNaiToCao}
                    dataSum={this.state.dataSum}
                    hidePagination={true}
                    numberColumnHeader={19}
                    ThongKeBaoCao={true}
                    dataList={this.state.rowData}
                    hideExport={true}
                    parent={this}
                    tableLoading={this.state.tableLoading}>
                    <RowItemQLNNKNTC/>
                  </DataTable>
                </ShowIf>
                <ShowIf condition={this.state.data.loaiBaoCao == 'KET_QUA_CHU_YEU_VE_CONG_TAC_PHONG_CHONG_THAM_NHUNG'}>
                  <TableKetQuaPhongChongThamNhung
                    addNew={false}
                    touchMove={true}
                    header={header.thongKeBaoCaoGiaiQuyetDonTC}
                    dataList={this.state.rowData}
                    hidePagination
                    parent={this}
                    hideExport={true}
                    ThongKeBaoCao={true}
                    LapBaoCao={true}
                    numberColumnHeader={33}
                    dataSum={this.state.dataSum}
                    tableLoading={this.state.tableLoading}
                  />
                </ShowIf>
                <ShowIf condition={this.state.data.loaiBaoCao == 'SO_LIEU_KE_KHAI_XAC_MINH_TAI_SAN'}>
                  <DataTable
                    touchMove={true}
                    header={header.tongHopSoLieu}
                    dataSum={this.state.dataSum}
                    hidePagination={true}
                    numberColumnHeader={12}
                    ThongKeBaoCao={true}
                    dataList={this.state.rowData}
                    hideExport={true}
                    parent={this}
                    tableLoading={this.state.tableLoading}>
                    <RowItemSLKKXMTS/>
                  </DataTable>
                </ShowIf>
            </div>
            <div className='row pl15 pr15 pb15'>
              <span className='big-border'></span>
            </div>
            <div className='row pl30 pr30 '>
              <ContainerFileDinhKem label="3. Danh sách văn bản xử lý" labelClass="title-14" disableTopLine={true} disableAttachFile={true} dataShow={this.state.data.listTaiLieuBaoCao}/>
            </div>
          </div>
          <div className="pt30">
            <div className="box-bottom">
              <Button type="button" className="btn-action btn-close" onClick={browserHistory.goBack}><span>Đóng</span></Button>
            </div>
          </div>
        </div>
      </MasterLayout>
    );
  }
}

export default ChiTietBaoCaoTaiDonVi;



// WEBPACK FOOTER //
// ./src/components/modules/bao-cao-tong-hop/ChiTietBaoCaoTaiDonVi.jsx